import { Component, HostListener, Input, ViewChild } from "@angular/core";

import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { Member } from "app/service/member/member";
import { ShareService } from "app/service/share/share.service";
import * as moment from "moment";
import { ModalDirective } from "ngx-bootstrap/modal";
import { AuthService } from "../../../service/auth/auth.service";
import { GtmService } from "../../../service/gtm/gtm.service";
import { Item, RentalReservation, RentalTable } from "../../../service/rental/rental";
import { RentalService } from "../../../service/rental/rental.service";
import { getTimeIndex } from "../rental";

@Component({
  selector: 'app-rental-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  providers: [ShareService, RentalService, DatePipe]
})
export class RentalItemComponent {
  @Input() public category: string;
  @Input() public groupIndex: number;

  isMobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerHeight = window.innerHeight - (window.innerWidth > 768 ? 105 : 70);
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
      this.onFilter(this.filter)
    }
  }

  timeLeftPos: number = 0;
  onTableScroll(event) {
    this.timeLeftPos = event.target.scrollLeft
  }

  location: string;
  me: Member;

  table;
  fixedThead;
  theadTds;
  fixedTheadTds;

  durationText = {
    'DURATION060': '1시간',
    'DURATION090': '1시간 30분',
    'DURATION120': '2시간',
    'DURATION240': '4시간'
  };
  durations: string[] = [
    'DURATION060', 'DURATION090', 'DURATION120', 'DURATION240'
  ];
  durationsMultiple = {
    'DURATION060': 2,
    'DURATION090': 3,
    'DURATION120': 4,
    'DURATION240': 8
  };

  dayOfTheWeeks: string[] = ['일', '월', '화', '수', '목', '금', '토'];

  startTimes: string[] = ['0800', '0830', '0900', '0930', '1000', '1030', '1100', '1130', '1200', '1230', '1300', '1330',
    '1400', '1430', '1500', '1530', '1600', '1630', '1700', '1730', '1800', '1830', '1900', '1930', '2000', '2030',
    '2100', '2130', '2200'];
  times: string[] = ['08:00', '', '09:00', '', '10:00', '', '11:00', '', '12:00', '', '13:00', '',
    '14:00', '', '15:00', '', '16:00', '', '17:00', '', '18:00', '', '19:00', '', '20:00', '',
    '21:00', '', '22:00'];
  roomTimes: string[] = ['08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
    '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30',
    '21:00', '21:30', '22:00', '22:30'];

  startTimeIndex = {};
  roomTimeIndex = {};
  durationIndex = {};

  items: Item[];
  reservations: RentalReservation[] = [];
  reservedTable: any[][] = [];

  tablePage: number = 1;
  tableSize: number = 10;
  myReservationCache: any[] = [];

  get myReservations(): RentalReservation[] {
    return this.myReservationCache
      .slice((this.tablePage - 1) * this.tableSize, this.tablePage * this.tableSize);
  }

  getGroupString(groupIndex: string | number) {
    switch (Number(groupIndex)) {
      case 1: return '촬영 관련 기기';
      case 2: return '젠더/프리젠터';
      case 3: return '카트/입간판';
      case 4: return '기타';
      default: return '';
    }
  }

  getItems(location: string, groupIndex: number, date: Date | undefined) {
    let dateObj = date || new Date();
    let dateTxt = moment(dateObj).format('YYYY-MM-DD')

    this.rentalService.getItems(location, this.getGroupString(groupIndex), dateTxt).take(1).subscribe(
      items => {
        this.items = items;
        this.tblStore = this.buildTableStore(items);
        this.location = location;

        this.getReservations();
        this.getMyReservations();
      }
    );
  }
  private getReservations() {
    this.rentalService.getReservations(this.location, this.getGroupString(this.groupIndex), this.onGetDate()).take(1).subscribe(
      reservations => {
        this.tablePage = 1;
        this.reservedTable = [];
        this.reservations = reservations;

        this.reservations.forEach(reservation => {
          const [startTimeIndex, endTimeIndex] = getTimeIndex(reservation);

          for (let i = startTimeIndex; i <= endTimeIndex; i++) {
            if (!this.reservedTable[reservation.item.id]) this.reservedTable[reservation.item.id] = [];
            this.reservedTable[reservation.item.id][i] = {
              'reservation': reservation,
              'Top': startTimeIndex === i,
              'Bottom': endTimeIndex === i,
              'drawTop': !!i
            };
          }
        });

        this.makeTableCells();
      }
    );
  }

  private getMyReservations() {
    this.rentalService.getMyReservations(this.location, this.getGroupString(this.groupIndex)).take(1).subscribe(
      reservations => {
        this.myReservationCache = reservations;
      }
    )
  }

  ngOnChanges() {
    let date = this.route.snapshot.queryParams["date"];
    date = date ? moment(date, 'YYYY-MM-DD').toDate() : new Date();
    this.setDate(date);

    this.location = this.category;
    this.getItems(this.location, this.groupIndex, date);
  }

  onChangePage(page) {
    this.tablePage = page.page
  }

  today: string;
  lastDay: string;
  startDate: Date;
  endDate: Date;
  innerHeight: number;

  constructor(
    private shareService: ShareService,
    private rentalService: RentalService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private gtmService: GtmService,
    private datePipe: DatePipe,
  ) {

    this.innerHeight = window.innerHeight - (window.innerWidth > 768 ? 105 : 70);
    this.isMobile = (window.innerWidth < 768);

    this.startDate = moment().toDate();
    this.endDate = moment().add(2, 'month').toDate();
    this.today = moment().format('YYYY-MM-DD');
    this.lastDay = moment().add(2, 'month').format('YYYY-MM-DD');

    let date = this.route.snapshot.queryParams["date"];
    date = date ? moment(date, 'YYYY-MM-DD').toDate() : new Date();
    this.setDate(date);

    this.startTimes.forEach((value, index) => this.startTimeIndex[value] = index);
    this.durations.forEach((value, index) => this.durationIndex[value] = index + 1);
    this.roomTimes.forEach((value, index) => this.roomTimeIndex[value] = index);
    this.gtmService.pageViewWithPage({
      'path': this.route.snapshot['_routerState'].url,
      'title': 'Meeting Room',
      'breadcrumb': 'Home > Member > Meeting Room'
    });

    this.shareService.awaitMe().take(1).subscribe(
      me => {
        this.me = me;
        this.location = me.location.key
      }
    )
  }

  private setDate(date: Date) {
    this.year = date.getFullYear();
    this.month = date.getMonth() + 1;
    this.day = date.getDate();
    this.dayOfTheWeek = this.dayOfTheWeeks[date.getDay()];
    this.dt = date
  }

  tblStore: RentalTable = new RentalTable()
  buildTableStore(items): RentalTable {
    const rtn = {
      header: [],
      items: [],
    }

    const getScrollbarWidth = function (recalculate) {
      var div1, div2;
      div1 = document.createElement('div');
      div2 = document.createElement('div');
      div1.id = "div1";
      div2.id = "div2";
      div1.style.width = div2.style.width = div1.style.height = div2.style.height = '100px';
      div1.style.overflow = 'scroll';
      div2.style.overflow = 'hidden';
      document.body.appendChild(div1);
      document.body.appendChild(div2);
      let scrollbarWidth = Math.abs(div1.scrollHeight - div2.scrollHeight);
      div1.remove();
      div2.remove();
      return scrollbarWidth;
    }();

    const tableWidth = 927 - 47 - getScrollbarWidth // 테이블 폭, 시간 셀 폭, 스크롤 폭
    items.map((item) => {
      rtn.header.push({ text: item.itemName, count: 1, width: Math.floor(tableWidth / items.length) });
    });

    return rtn
  }

  filter: string = 'seongsu';
  onFilter(filter) {
    this.filter = filter;

    if (this.tableCells) {
      this.tableCells = this.tableCells.map(col => {
        return col.map(item => {
          return {
            ...item,
            isShow: this.onShowBody(item.room)
          }
        })
      })
    }
  }

  tableCells: any[][] = []

  makeTableCells() {
    if (!this.items) return []
    this.tableCells = []

    this.startTimes.map((startTime) => {
      this.tableCells.push(
        this.items.map(item => {
          return {
            classList: this.onTableClass(startTime, item),
            isShow: this.onShowBody(item),
            item,
          }
        }
        ))
    })
  }

  isFree(startTime: string, item: Item): boolean {
    if (!this.items) return false;

    let rtn = true
    let n = this.startTimeIndex[startTime]

    item.policy.times.map(({ start, end }) => {
      let s = this.roomTimeIndex[start]
      let e = this.roomTimeIndex[end]

      if (rtn && (n >= s && n < e)) rtn = false
    })

    return rtn;
  }

  isPast(startTime: string): boolean {
    if (moment(`${this.onGetDate()} ${startTime}`, 'YYYY-MM-DD hhmm').diff(moment(), 'minutes') <= -10) return true;
    return false;
  }

  isReserved(startTime: string, item: Item): boolean {
    if (!this.reservations) return false;
    if (!this.reservedTable[item.id]) return false;

    return !!this.reservedTable[item.id][this.startTimeIndex[startTime]];
  }

  isDrawTop(startTime: string, item: Item): boolean {
    if (!this.reservations) return false;
    if (!this.reservedTable[item.id]) return false;
    if (!this.reservedTable[item.id][this.startTimeIndex[startTime]]) return false;

    return this.reservedTable[item.id][this.startTimeIndex[startTime]].drawTop;
  }

  isTop(startTime: string, item: Item): boolean {
    if (!this.reservations) return false;
    if (!this.reservedTable[item.id]) return false;
    if (!this.reservedTable[item.id][this.startTimeIndex[startTime]]) return false;

    return this.reservedTable[item.id][this.startTimeIndex[startTime]].Top;
  }

  isBottom(startTime: string, item: Item): boolean {
    if (!this.reservations) return false;
    if (!this.reservedTable[item.id]) return false;
    if (!this.reservedTable[item.id][this.startTimeIndex[startTime]]) return false;

    return this.reservedTable[item.id][this.startTimeIndex[startTime]].Bottom;
  }

  onTableClass(startTime: string, item: Item) {
    let classList = [];
    let reservation;

    try {
      reservation = this.reservedTable[item.id][this.startTimeIndex[startTime]].reservation;
    } catch (e) {
      reservation = null;
    }

    if (true || this.isFree(startTime, item)) classList.push('free')
    if (this.isPast(startTime)) classList.push('past')
    if (this.isReserved(startTime, item)) classList.push('reserved')
    if (this.isDrawTop(startTime, item)) classList.push('draw-top')
    if (this.isTop(startTime, item)) classList.push('top')
    if (this.isBottom(startTime, item)) classList.push('bottom')

    if (reservation === null) { }
    else if (reservation.email == this.me.email) classList.push('me');
    else if (reservation.clt_nm == this.me.team.name) classList.push('company');

    return classList;
  }

  onClick(startTime: string, item) {
    let reservation = null;
    let startTimeIndex = this.startTimeIndex[startTime];
    if (this.reservations && this.reservedTable[item.item.id] && this.reservedTable[item.item.id][startTimeIndex]) {
      reservation = this.reservedTable[item.item.id][startTimeIndex].reservation;
    }

    // 예약 가능 확인
    if (reservation == null) {
      let current = this.onGetDate();
      if (this.today > current || this.lastDay < current || item.classList.findIndex(o => o === 'active') !== -1) {
        window.alert('예약이 가능하지 않습니다.');
        return;
      }
    }

    let duration = 16;
    if (reservation == null && this.reservations) {
      duration = 0;
      for (let i = 0; i < 16; i++) {
        if (this.reservedTable[item.id] && this.reservedTable[item.id][startTimeIndex + i] || (startTimeIndex + i) >= this.startTimes.length - 1) {
          break;
        }
        duration = i + 1;
      }
    }

    this.showModal(reservation, item.item, startTime, duration);
  }

  onShowHeader(cond) {
    return this.filter === cond || (window.innerWidth > 768);
  }

  onShowBody(item: Item) {
    return true;
  }

  ///////////////////////////////
  showCalendar: boolean = false;
  dt: Date = new Date;

  year: number;
  month: number;
  day: number;
  dayOfTheWeek: string;

  onPrevDay() {
    const date = new Date(this.year, this.month - 1, this.day - 1);
    // if (this.today > moment(date).format('YYYY-MM-DD')) {
    //   alert(`${this.today} ~ ${this.lastDay} 일정만 예약 가능합니다.`);;
    //   return;
    // }

    this.router.navigate([], { queryParams: { date: moment(date).format('YYYY-MM-DD') }, replaceUrl: true });
    this.setDate(date);
    this.getItems(this.location, this.groupIndex, date);
  }

  onNextDay() {
    const date = new Date(this.year, this.month - 1, this.day + 1);
    if (this.lastDay < moment(date).format('YYYY-MM-DD')) {
      alert(`${this.today} ~ ${this.lastDay} 일정만 예약 가능합니다.`);
      return;
    }

    this.router.navigate([], { queryParams: { date: moment(date).format('YYYY-MM-DD') }, replaceUrl: true });
    this.setDate(date);
    this.getItems(this.location, this.groupIndex, date);
  }

  onSelectCalendar(date) {
    this.showCalendar = false;
    let ipt = date.getFullYear ? date : moment(date, 'YYYY-MM-DD').toDate();

    this.router.navigate([], { queryParams: { date: moment(ipt).format('YYYY-MM-DD') }, replaceUrl: true });
    this.setDate(ipt);
    this.getItems(this.location, this.groupIndex, date);
  }

  // ////////////////////////////// Modal ///////////////////////

  @ViewChild('modal') modal: ModalDirective;
  isModalShown: boolean = false;

  rental: RentalReservation;
  item: Item;
  startTime: string;
  duration: number;
  rsv_cache: {
    time_use_end: string;
  };

  showModal(rental: RentalReservation, item: Item, startTime: string, duration: number) {
    this.rental = rental;
    this.item = item;
    this.startTime = startTime;
    this.duration = duration;

    this.isModalShown = true;
    this.rsv_cache = {
      time_use_end: '',
    }
    this.modal.show();
  }

  onHide(): void {
    this.isModalShown = false;
  }

  onGetDate(spliter = '-') {
    return `${this.year}${spliter}${(this.month >= 10) ? this.month : '0' + this.month}${spliter}${(this.day >= 10) ? this.day : '0' + this.day}`;
  }

  convDe_use(de_use) {
    return moment(de_use, 'YYYYMMDD').format('YYYY-MM-DD')
  }

  onReserve(f, item: Item) {
    let rental = new RentalReservation();
    if (!f.time_use_end) {
      window.alert('사용시간을 선택해 주세요.');
      return;
    }

    if (item.count > 1) {
      if (!f.count) {
        window.alert('대여개수를 입력해주세요.');
        return;
      }
    }

    rental.item = item;
    rental.date = moment(this.dt).format('YYYY-MM-DD');
    rental.time_use_start = this.startTime;
    rental.time_use_end = this.startTimes[this.startTimeIndex[this.startTime] + this.durationsMultiple[f.time_use_end]];
    rental.count = f.count || 1;
    rental.location = this.location;

    this.rentalService.reserve(rental).take(1).subscribe(
      res => {
        this.getReservations();
        this.getMyReservations();
        this.modal.hide();
      },
      error => {
        this.getReservations();
        this.getMyReservations();
        this.modal.hide();

        window.alert(JSON.parse(error._body).message || '대여 물품을 예약할 수 없습니다.');
      }
    );
  }

  onIsCancel() {
    if (this.authService.isAdmin() ||
      this.rental.email == this.authService.getEmail()) {
      return true;
    }

    return false;
  }

  onClickTableCancel(reservation) {
    this.rental = reservation;
    this.onCancel();
  }

  onCancel() {
    let result = window.confirm('물품 예약을 취소합니다.');
    if (result == true) {
      this.rentalService.cancel(this.rental.id).take(1).subscribe(
        res => {
          this.modal.hide();
          this.getReservations();
          this.getMyReservations();
        },
        error => {
          window.alert('물품 예약을 취소할 수 없습니다.');
          this.modal.hide();
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/member/rental/item/item.component.ts